export default {
  name: 'CollaborationFileUpload',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    error: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Choose files',
    },
    accept: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: true,
    },
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  data() {
    return {
      files: [],
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.files = newVal;
        }
      }
    }
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const newFiles = Array.from(event.target.files);
      
      if (this.multiple) {
        this.files = [...this.files, ...newFiles];
      } else {
        this.files = newFiles;
      }
      
      this.$emit('input', this.files);
      
      // Reset the input to allow selecting the same file again
      event.target.value = '';
    },
    removeFile(index) {
      const updatedFiles = [...this.files];
      updatedFiles.splice(index, 1);
      this.files = updatedFiles;
      this.$emit('input', this.files);
    }
  }
}
